import Vue from 'vue'
import AscChips from '@/components/molecules/AscChips'

export default Vue.extend({
  components: {
    AscChips,
  },

  data: function () {
    return {}
  },

  computed: {
    getItems() {
      return this.params.data.issues.map(item => {
        return {
          value: item,
          text: item,
        }
      })
    },
  },

  template: `<asc-chips 
  :items="getItems" 
  close-hidden 
  style="margin-top:-4px;"/>`,
})
